<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <ChartTree /> -->
  </div>
</template>

<script>
// import ChartTree from "vue-material-design-icons/ChartTree.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiChartTree } from "@mdi/js"

export default {
  name: "ChartTreeIcon",
  components: {
    SvgIcon
    // ChartTree,
  },
  data() {
    return {
      path: mdiChartTree,
    }
  }
}
</script>
